module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "adventure": _vm.adventure,
      "adventureId": _vm.adventureId,
      "chapter": _vm.chapter,
      "chapterId": _vm.chapterId,
      "objectId": _vm.selectedObjectId,
      "object": _vm.selectedObject
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "background-color": "white",
      "margin-top": "20px"
    },
    attrs: {
      "id": "page-objects"
    }
  }, [_c('div', {
    staticClass: "mdl-grid mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "mdl-cell--4-col mdl-cell--12-col-tablet"
  }, [_c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp mdl-cell--12-col",
    attrs: {
      "id": "adv-table"
    }
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "position": "absolute",
      "top": "6px",
      "right": "5px"
    },
    on: {
      "click": _vm.createObject
    }
  }, [_vm._v("New Object")])])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable"
    }]
  }, _vm._l((_vm.chapter.objects), function(object, objectKey) {
    return _c('tr', {
      class: _vm.selectionClass(objectKey),
      attrs: {
        "name": objectKey
      },
      on: {
        "click": function($event) {
          _vm.selectObject(objectKey)
        }
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(object.name))]), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "objectKey": objectKey
      },
      on: {
        "click": _vm.deleteObject
      }
    }, [_c('i', {
      staticClass: "material-icons",
      attrs: {
        "objectKey": objectKey
      }
    }, [_vm._v("delete")])])])])
  })), _vm._v(" "), _c('tfoot', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "left",
      "margin": "0",
      "padding": "0",
      "width": "100%",
      "height": "60px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.user) ? _c('dropzone-firebase-multiple', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "folder": _vm.user.uid + '/' + _vm.adventureId + '/' + _vm.chapterId + '/objects',
      "el-ref": _vm.objectsRef
    }
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--8-col mdl-cell--12-col-tablet"
  }, [(_vm.selectedObjectId) ? _c('div', {
    staticStyle: {
      "background-color": "white",
      "padding-left": "30px",
      "text-align": "left"
    }
  }, [_c('h5', {
    staticClass: "mdl-cell--12-col"
  }, [_vm._v("Edit Object")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col",
    class: {
      'is-dirty': _vm.selectedObject.name
    }
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": _vm.selectedObject.name
    },
    on: {
      "input": _vm.updateName
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v("Name...")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--12-col"
  }, [(_vm.user) ? _c('dropzone-firebase', {
    attrs: {
      "dropzone-firebase": "",
      "file-name": _vm.selectedObjectId,
      "folder": _vm.user.uid + "/" + _vm.adventureId + "/" + _vm.chapterId + "/objects/",
      "bg-image": _vm.selectedObject.bg
    },
    on: {
      "upload": _vm.objectBgUpdate
    }
  }) : _vm._e()], 1)]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("widgets")]), _vm._v(" Objects")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57d3e3f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionObjects.vue
// module id = 309
// module chunks = 0